var CsmToastSeverity;
(function (CsmToastSeverity) {
    CsmToastSeverity["Success"] = "success";
    CsmToastSeverity["Warning"] = "warning";
    CsmToastSeverity["Error"] = "error";
    CsmToastSeverity["Info"] = "info";
})(CsmToastSeverity || (CsmToastSeverity = {}));
var CsmToastClosingType;
(function (CsmToastClosingType) {
    CsmToastClosingType[CsmToastClosingType["ByCloseMethod"] = 0] = "ByCloseMethod";
    CsmToastClosingType[CsmToastClosingType["ByUser"] = 1] = "ByUser";
    CsmToastClosingType[CsmToastClosingType["ByTimeout"] = 2] = "ByTimeout";
})(CsmToastClosingType || (CsmToastClosingType = {}));
export { CsmToastSeverity as C, CsmToastClosingType as a };
